import { TabConfig } from './types';
export type DragSourceType = 'floating' | 'minimized' | 'regular';
export type DragTargetType = 'floating' | 'minimized' | 'regular';
export interface GlobalDragData {
    isDragging: boolean;
    sourceType: DragSourceType;
    sourcePanelId?: string;
    sourceGroupId?: string;
    sourceTabId?: string;
    targetType?: DragTargetType;
    targetPanelId?: string;
    targetGroupId?: string;
    targetTabId?: string;
    position?: { x: number; y: number };
    tabData?: TabConfig;
    dragOrigin?: { x: number; y: number };
    dragGhostPos?: { x: number; y: number };
    draggedIcon?: string | null;
    draggedPanel?: string | null;
    dragGhostIcon?: any;
    isIconDragging?: boolean;
    ghostType?: 'regular' | 'minimized' | 'floating';
    ghostData?: any;
}
type DragStateListener = (state: GlobalDragData | null) => void;
class GlobalDragState {
    private state: GlobalDragData | null = null;
    private listeners: Set<DragStateListener> = new Set();
    getState() {
        return this.state;
    }
    setState(newState: GlobalDragData | null) {
        this.state = newState;
        this.listeners.forEach((fn) => fn(this.state));
    }
    subscribe(fn: DragStateListener) {
        this.listeners.add(fn);
        return () => this.listeners.delete(fn);
    }
    clear() {
        this.setState(null);
    }
}
export const globalDragState = new GlobalDragState();
